import { render } from "./fizjoOptinPage.vue?vue&type=template&id=1118b658&scoped=true"
import script from "./fizjoOptinPage.vue?vue&type=script&lang=js"
export * from "./fizjoOptinPage.vue?vue&type=script&lang=js"

import "./fizjoOptinPage.vue?vue&type=style&index=0&id=1118b658&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1118b658"]])

export default __exports__